import { render, staticRenderFns } from "./krasTargetProcess.vue?vue&type=template&id=70bae490"
import script from "./krasTargetProcess.vue?vue&type=script&lang=js"
export * from "./krasTargetProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70bae490')) {
      api.createRecord('70bae490', component.options)
    } else {
      api.reload('70bae490', component.options)
    }
    module.hot.accept("./krasTargetProcess.vue?vue&type=template&id=70bae490", function () {
      api.rerender('70bae490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/plan/krasTargetProcess.vue"
export default component.exports